(function() {
  var skipNextValidation = false;

  function hasCustomBalmsInCart() {
    var items = document.querySelectorAll('#t4s-mini_cart [data-cart-item]');
    for (var i = 0; i < items.length; i++) {
      var type = (items[i].getAttribute('data-product-type') || '').toLowerCase();
      if (type === 'custom lip balm') return true;
    }
    return false;
  }

  function getField() { return document.getElementById('cart-company-field'); }
  function getInput() { return document.getElementById('cart-company-name'); }
  function getError() { return document.getElementById('cart-company-error'); }

  function updateVisibility() {
    var field = getField();
    if (!field) return;
    var show = hasCustomBalmsInCart();
    field.style.display = show ? '' : 'none';
    if (!show) {
      var input = getInput();
      var error = getError();
      if (input) input.classList.remove('is--invalid');
      if (error) error.style.display = 'none';
    }
  }

  function handleCheckoutClick(e) {
    var btn = e.target.closest ? e.target.closest('button[name="checkout"]') : null;
    if (!btn) return;

    if (skipNextValidation) {
      skipNextValidation = false;
      return;
    }

    if (!hasCustomBalmsInCart()) return;

    var input = getInput();
    var error = getError();
    var value = input ? input.value.trim() : '';

    if (!value) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (input) {
        input.classList.add('is--invalid');
        input.focus();
      }
      if (error) error.style.display = '';
      return;
    }

    input.classList.remove('is--invalid');
    if (error) error.style.display = 'none';

    e.preventDefault();
    e.stopImmediatePropagation();

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: { 'Company Name': value } })
    }).then(function() {
      skipNextValidation = true;
      btn.click();
    }).catch(function() {
      skipNextValidation = true;
      btn.click();
    });
  }

  var checkoutTouchY = 0;

  function handleCheckoutTouchStart(e) {
    var btn = e.target.closest ? e.target.closest('button[name="checkout"]') : null;
    if (btn) checkoutTouchY = e.touches[0].clientY;
  }

  function handleCheckoutTouchEnd(e) {
    var btn = e.target.closest ? e.target.closest('button[name="checkout"]') : null;
    if (!btn) return;
    var dy = Math.abs(e.changedTouches[0].clientY - checkoutTouchY);
    if (dy < 15) {
      setTimeout(function() { btn.click(); }, 0);
    }
  }

  function bindEvents() {
    var drawer = document.getElementById('t4s-mini_cart');
    if (!drawer) return;
    drawer.removeEventListener('click', handleCheckoutClick, true);
    drawer.addEventListener('click', handleCheckoutClick, true);

    drawer.removeEventListener('touchstart', handleCheckoutTouchStart, true);
    drawer.addEventListener('touchstart', handleCheckoutTouchStart, true);
    drawer.removeEventListener('touchend', handleCheckoutTouchEnd, true);
    drawer.addEventListener('touchend', handleCheckoutTouchEnd, true);

    var input = getInput();
    if (input && !input._companyBound) {
      input._companyBound = true;
      input.addEventListener('input', function() {
        if (input.value.trim()) {
          input.classList.remove('is--invalid');
          var error = getError();
          if (error) error.style.display = 'none';
        }
      });
    }
  }

  function init() {
    updateVisibility();
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:updated', function() {
    setTimeout(function() {
      updateVisibility();
      bindEvents();
    }, 100);
  });

  var observer = new MutationObserver(function() {
    updateVisibility();
    bindEvents();
  });

  function observeCartItems() {
    var target = document.querySelector('#t4s-mini_cart [data-cart-items]');
    if (target) {
      observer.observe(target, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartItems);
  } else {
    observeCartItems();
  }

  document.addEventListener('cart:updated', function() {
    setTimeout(observeCartItems, 150);
  });
})();
